import MediumHeading from "../UI/MediumHeading";
import SmallHeading from "../UI/SmallHeading";
import Rammy3 from "../../assets/images/Rammy3.jpg";
import Button from "../UI/Button";
import Tile from "../UI/Tile";
import Resume from "../../assets/RameshOj.pdf";
import "./style.css";

// Qualification Component
// This component displays educational qualifications with images and descriptions
export default function Qualification() {
  return (
    <div id="qual" className="container" style={{ padding: "50px 0" }}>
      <SmallHeading text="Qualification" />
      <MediumHeading text="Education" />
      <div
        className="flexRow flexCol justify-sb align-center"
        style={{ margin: "40px 0" }}
      >
        <div data-aos="fade-up-right">
          <div className="eduImgContainer">
            <img src={Rammy3} alt="" />
          </div>
        </div>

        <div>
          <Tile
            title="AKTU"
            mediumTitle="B.Tech Electrical Engineering"
            desc="Scored 1st Division in Graduation"
          />
          <Tile
            title="CBSE"
            mediumTitle="Senior Secondary (PCM)"
            desc="Scored 1st Division in Intermediate"
          />
          <Tile
            title="CBSE"
            mediumTitle="High School"
            desc="Scored 1st Division in 10th"
          />
          <div className="flexRow">
            <div className="mlr-10">
              <Button href="tel:+919540205885" label="Hire Me" />
            </div>
            <div className="mlr-10">
              <Button href={Resume} label="Download CV " inverse="true" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
